interface OrderPriceI {
  stickers: CustomizerStickerI[];
  item: ItemI;
}

export default function (order: OrderPriceI, loyaltyDiscount: number = 0) {
  const stickers = calculateStickerList(order.stickers);

  const k = 1 - loyaltyDiscount / 100;

  const stickerPrice = stickers.reduce((acc, sticker) => acc + sticker.price, 0) * k;
  const itemPrice = order.item.discountless ? order.item.price : order.item.price * k;
  return stickerPrice + itemPrice;
}
